import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import type { MouseEventHandler } from 'react'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  isLoginForMemberSavings?: boolean
  kind?: 'primary' | 'secondary' | 'tertiary'
}

function BedbankMetaSearchTileSignUpButton({ isLoginForMemberSavings, kind = 'primary' }: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    showModal(<AccountAccessModal />)
  }, [showModal])

  const signUpSaveMoreLabel = intl.formatMessage({
    id: 'x0ql5pibUpYrhFV2PvsY',
    defaultMessage: 'Sign up & save more',
    description: 'Bedbank meta search tile button prompting users to sign up for member savings',
  })
  const signUpFreeLabel = intl.formatMessage({
    id: 'UDKLUstfC6DW5BBi08U0',
    defaultMessage: 'Sign up for free',
    description: 'Bedbank meta search tile button prompting users to sign up for free',
  })

  if (isLoginForMemberSavings) {
    return <TextButton kind={kind} nonInteractable onClick={handleClick}>
      {signUpSaveMoreLabel}
    </TextButton>
  }

  return <TextButton kind={kind} nonInteractable onClick={handleClick}>
    {signUpFreeLabel}
  </TextButton>
}

export default BedbankMetaSearchTileSignUpButton
